function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M50 7.5H10C7.23858 7.5 5 9.73858 5 12.5V37.5C5 40.2614 7.23858 42.5 10 42.5H50C52.7614 42.5 55 40.2614 55 37.5V12.5C55 9.73858 52.7614 7.5 50 7.5Z",
  stroke: "#2F2E41",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20 52.5H40",
  stroke: "#2F2E41",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M30 42.5V52.5",
  stroke: "#2F2E41",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.91eddd8ca39a42f025d358aef6ab25e3.svg";
export { ForwardRef as ReactComponent };